module.exports = __webpack_public_path__ + "img/visa-debito-premium.c6dc5846.png";